import { render, staticRenderFns } from "./ppt.vue?vue&type=template&id=3a189ac3&scoped=true"
import script from "./ppt.vue?vue&type=script&lang=js"
export * from "./ppt.vue?vue&type=script&lang=js"
import style0 from "./ppt.vue?vue&type=style&index=0&id=3a189ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a189ac3",
  null
  
)

export default component.exports